import '@/app/app.css';
import './content.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {});
